import { Toaster } from './components/ui/toaster'
import { Toaster as Sonner } from './components/ui/sonner'
import { GlobalStyle } from './global'
import { AppRoutes } from './routes'

function App() {
  return (
    <>
      <GlobalStyle />
      <AppRoutes />
      <Toaster />
      <Sonner />
    </>
  )
}

export default App
